import { useGate, useUnit } from "effector-react"
import cn from "clsx"

import { userAccountModel } from "../../models"
import { UserAccountFormHeader } from "../user-account-form-header"
import { UserAccountInfoSkeleton } from "../../components"
import { UserAccountFormContent } from "../user-account-form-content"

import styles from "./user-account-form.module.pcss"

type UserAccountFormProps = {
  onMobileClose?: () => void
}

export const UserAccountForm = ({ onMobileClose }: UserAccountFormProps) => {
  const isLoading = useUnit(userAccountModel.$isPageLoading)
  const withMobile = Boolean(onMobileClose)

  useGate(userAccountModel.ModalGate)

  return (
    <div className={cn(styles.formContainer, { [styles.mobileFormContainer]: withMobile })}>
      {!withMobile && <UserAccountFormHeader />}
      <div className={cn(styles.contentContainer, { [styles.mobileContentContainer]: withMobile })}>
        {isLoading ? <UserAccountInfoSkeleton /> : <UserAccountFormContent onMobileClose={onMobileClose} />}
      </div>
    </div>
  )
}
